module.exports = __webpack_public_path__ + "img/inspiration-1@2x.10e6e60.jpg";